export default {
    // Header Section
    "discover_your": "अपने",
    "sadesati": "साढ़े साती",
    "saturn_influence_analysis": "शनि प्रभाव विश्लेषण",
    "sadesati_description": "अपने जीवन पर शनि के प्रभाव का विस्तृत विश्लेषण प्राप्त करें, चुनौतियों को विकास और सफलता के अवसरों में बदलने के लिए अंतर्दृष्टि और उपायों के साथ।",

    "sadesati_your": "साढ़े साती विश्लेषण",

    // Service Information
    "enter_details_for_sadesati": "साढ़े साती विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_sadesati_analysis": "संपूर्ण साढ़े साती विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_sadesati_analysis_note": "शनि के गोचर प्रभावों का गहरा विश्लेषण और व्यक्तिगत उपचारात्मक मार्गदर्शन",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_saturn_influence": "आपके नाम की तरंगें शनि की ऊर्जा पैटर्न के साथ मेल खाती हैं",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_moon_position": "आपकी चंद्र राशि और साढ़े साती चरण निर्धारित करने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_sadesati": "सटीक चंद्र राशि गणना के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_essential_for_sadesati": "स्थान निर्देशांक ग्रहीय गणना को प्रभावित करते हैं",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका साढ़े साती विश्लेषण चुनी गई भाषा में प्रदान किया जाएगा",

    // Core SadeSati Features
    "sadesati_phase_identification": "साढ़े साती चरण पहचान",
    "saturn_effects_analysis": "शनि प्रभाव विश्लेषण",
    "remedies_and_solutions": "उपचार और समाधान",
    "timeline_predictions": "समयरेखा भविष्यवाणी",
    "life_guidance_during_sadesati": "साढ़े साती के दौरान जीवन मार्गदर्शन",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके साढ़े साती विश्लेषण में क्या शामिल है",
    "complete_sadesati_timeline": "संपूर्ण साढ़े साती समयरेखा",
    "saturn_influence_analysis": "शनि प्रभाव विश्लेषण",
    "personalized_remedies": "व्यक्तिगत उपचार",
    "life_guidance_insights": "जीवन मार्गदर्शन और अंतर्दृष्टि",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा साढ़े साती विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "sadesati_analysis_processing": "आपका साढ़े साती विश्लेषण हमारे विशेषज्ञ वैदिक ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको अपने जीवन पर शनि के वर्तमान प्रभाव में विस्तृत अंतर्दृष्टि प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_12_hours_delivery_note": "आपकी विस्तृत साढ़े साती रिपोर्ट 12 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका साढ़े साती विश्लेषण पैकेज",
    "detailed_sadesati_report": "व्यापक साढ़े साती रिपोर्ट (पीडीएफ)",
    "saturn_phase_analysis": "शनि चरण और समयरेखा विश्लेषण",
    "remedial_measures_guidance": "उपचारात्मक उपाय और मार्गदर्शन",
    "life_predictions_timeline": "जीवन भविष्यवाणी और समयरेखा",
    "spiritual_guidance_saturn": "शनि काल के लिए आध्यात्मिक मार्गदर्शन",

    // Visual Content
    "sample_sadesati_analysis": "नमूना साढ़े साती विश्लेषण",
    "sadesati_phase": "साढ़े साती चरण",
    "sample_sadesati_description": "वर्तमान में चरम चरण में - अधिकतम शनि प्रभाव अवधि",
    "sample_sadesati_preview": "चरण विवरण के साथ आपके व्यक्तिगत साढ़े साती विश्लेषण का पूर्वावलोकन",
    "sadesati_phases": "साढ़े साती चरण",

    // SadeSati Phase Types
    "rising_phase": "चढ़ता चरण",
    "peak_phase": "चरम चरण",
    "setting_phase": "ढलता चरण",

    // Status & Processing
    "your_sadesati_analysis_status": "आपके साढ़े साती विश्लेषण की स्थिति",
    "processing_your_analysis": "शनि के प्रभाव का विश्लेषण",
    "analysis_processing_message": "हमारे वैदिक ज्योतिष विशेषज्ञ शनि की वर्तमान स्थिति और आपके जीवन पथ पर इसके प्रभावों का अध्ययन कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_12_hours": "रिपोर्ट 12 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "ज्योतिष सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // SadeSati-Specific Elements
    "saturn_transit": "शनि गोचर",
    "moon_sign": "चंद्र राशि (राशि)",
    "saturn_position": "शनि की वर्तमान स्थिति",
    "sadesati_duration": "साढ़े साती अवधि",
    "phase_timeline": "चरण समयरेखा",
    "saturn_effects": "शनि के प्रभाव",

    // Phase Analysis
    "first_phase": "प्रथम चरण (2.5 वर्ष)",
    "second_phase": "द्वितीय चरण (2.5 वर्ष)",
    "third_phase": "तृतीय चरण (2.5 वर्ष)",
    "phase_characteristics": "चरण विशेषताएं",
    "phase_challenges": "चरण चुनौतियां",
    "phase_opportunities": "चरण अवसर",

    // Effects & Influences
    "career_effects": "करियर और व्यावसायिक प्रभाव",
    "health_effects": "स्वास्थ्य और कल्याण प्रभाव",
    "relationship_effects": "रिश्ते के प्रभाव",
    "financial_effects": "वित्तीय प्रभाव",
    "mental_effects": "मानसिक और भावनात्मक प्रभाव",
    "spiritual_effects": "आध्यात्मिक विकास प्रभाव",

    // Remedies & Solutions
    "saturn_remedies": "शनि उपाय",
    "gemstone_recommendations": "रत्न सिफारिशें",
    "mantra_chanting": "मंत्र जाप",
    "fasting_recommendations": "उपवास दिशा-निर्देश",
    "charity_suggestions": "दान गतिविधियां",
    "worship_rituals": "पूजा अनुष्ठान",
    "lifestyle_changes": "जीवनशैली संशोधन",

    // Timeline & Predictions
    "current_phase": "वर्तमान चरण",
    "remaining_duration": "शेष अवधि",
    "next_phase_start": "अगला चरण शुरुआत तिथि",
    "sadesati_end_date": "साढ़े साती समाप्ति तिथि",
    "monthly_predictions": "मासिक भविष्यवाणी",
    "yearly_overview": "वार्षिक अवलोकन",

    // Detailed Analysis Sections
    "saturn_mythology": "वैदिक पुराणों में शनि",
    "karmic_lessons": "कार्मिक सबक",
    "past_life_karma": "पूर्वजन्म कर्म",
    "spiritual_significance": "आध्यात्मिक महत्व",
    "growth_opportunities": "विकास के अवसर",
    "life_lessons": "शनि से जीवन सबक",

    // Practical Guidance
    "do_and_dont": "साढ़े साती के दौरान करें और न करें",
    "precautions": "बरती जाने वाली सावधानियां",
    "best_practices": "सर्वोत्तम प्रथाएं",
    "meditation_practices": "ध्यान अभ्यास",
    "yoga_recommendations": "योग सिफारिशें",
    "dietary_guidelines": "आहार दिशा-निर्देश",

    // Support & Guidance
    "coping_strategies": "सामना करने की रणनीतियां",
    "stress_management": "तनाव प्रबंधन",
    "emotional_support": "भावनात्मक सहायता तकनीकें",
    "family_guidance": "पारिवारिक रिश्ते मार्गदर्शन",
    "professional_guidance": "व्यावसायिक जीवन मार्गदर्शन",

    // Advanced Analysis
    "saturn_aspects": "शनि की दृष्टि",
    "planetary_combinations": "ग्रहीय संयोजन",
    "dasha_analysis": "दशा काल विश्लेषण",
    "transit_effects": "गोचर प्रभाव",
    "yogas_formed": "शनि के साथ बने योग"
};
